<div class="row mx-0 mb-2">
  <div class="col-6 px-0 text-start">
    <app-patient-nav [patient]="patient" />
  </div>
  <div class="col-6 text-end">
    <app-patient-deactivate-button [patient]="patient" (patientDeactivated)="onPatientDeactivated($event)"/>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <h3 class="mb-4 phi">{{ patient.fullName }} ({{ patient.dob | date: 'MM/dd/yyyy' }}) @if (!active) {
      <span>- INACTIVE</span>
    }</h3>

    <div class="row">
      <div class="col">
        <strong>PATIENT ID:</strong>
        <div>{{ patient.id }}</div>
      </div>

      <div class="col">
        <strong>MAIN PATIENT ID:</strong>
        @if (patient.mainPatient) {
          <div>
            <a routerLink="/capture-admin/patients/{{ patient.mainPatient.id }}">
              {{ patient.mainPatient.id }}
            </a>
          </div>
        }
        @if (!patient.mainPatient) {
          <div>
            <app-blank-value-dash />
          </div>
        }
      </div>

      <div class="col">
        <strong>PATIENT STATUS:</strong>
        @if (active) {
          <div>Active</div>
        }
        @if (!active) {
          <div>
            Inactive ({{ patient.inactiveDate | date: 'MM/dd/yyyy' }})
          </div>
        }
      </div>

      <div class="col">
        <strong>CLIENT:</strong>
        <app-client-name [client]="patient.client" />
      </div>

      <div class="col">
        <strong>MRN:</strong>
        <div class="phi">{{ patient.mrn }}</div>
      </div>

      @if (healthGorillaActive) {
        <div class="col">
          <strong>HEALTH GORILLA ID:</strong>
          @if (patient.healthGorillaUrl) {
            <div class="phi">
              <a [href]="patient.healthGorillaUrl" target="_blank" rel="noopener">
                {{ patient.healthGorillaIdentifier }}
              </a>
            </div>
          } @else {
            <div>N/A</div>
          }
        </div>
      }
    </div>
  </div>
</div>
